import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.UPDATE_BAG_PARAM.REQUEST, saga.updateBagParam);
    yield takeLatest(ACTION.UPDATE_BAG_PARAM.SUCCESS, saga.onUpdateBagParamSuccess);
    yield takeLatest(ACTION.UPDATE_BAG_PARAM.FAILED, saga.onUpdateBagParamFailed);
}
